import { render } from "./bezigheden-step.vue?vue&type=template&id=08cc6d22"
import script from "./bezigheden-step.vue?vue&type=script&lang=js"
export * from "./bezigheden-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__